var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.actions.length)?_c('v-btn',{attrs:{"depressed":"","color":"primary"},on:{"click":_vm.openAction}},[_vm._v(" Podejmij działanie ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }